import { useCallback, useEffect, useState } from 'react';
export function useJsonApi(url){
  const [state,setState]=useState({data:null,loading:true,error:'',refreshedAt:null});
  const refresh=useCallback(async()=>{
    setState(s=>({...s,loading:true,error:''}));
    try{
      const r=await fetch(url,{cache:'no-store'}); const data=await r.json();
      if(!r.ok||data.error)throw new Error(data.error||`Request failed (${r.status})`);
      setState({data,loading:false,error:'',refreshedAt:new Date()});
    }catch(e){setState(s=>({...s,loading:false,error:e?.message||String(e)}));}
  },[url]);
  useEffect(()=>{refresh();const id=setInterval(refresh,300000);return()=>clearInterval(id);},[refresh]);
  return {...state,refresh};
}
